module.exports = __webpack_public_path__ + "static/img/xwyd.afcdab6a.png";